import { Field, Form, Formik, useFormikContext } from 'formik';
import PageContainer from '../../components/PageContainer';
import { useNavigate } from 'react-router';
import { useEffect, useRef } from 'react';
import { useAuth } from '../../common/context/AuthProvider';
import { AuthService } from '../../common/API/AuthService';
import { Link } from 'react-router-dom';
import Animated from '../../components/AnimatedComponent';
import Input from '../../components/forms/Input';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import { Button } from '@/components/ui/button';

const LoginScreen = () => {
  const { login, userData, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const formRef: any = useRef();

  const handleSubmit = () => {
    console.log(formRef.current.values);
    // login(formRef.current.values);
    AuthService.login(formRef.current.values)
      .then((res) => {
        console.log(res);
        login(res?.data);
      })
      .catch((error) => {
        console.log('GRESKAA IZ KOMPONENTE');
      });
  };

  useEffect(() => {
    if (isLoggedIn) navigate('/home');
  }, [isLoggedIn]);

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        tabNavigator: {
          hide: false,
        },
      }}
    >
      <ScrollableContainer className='flex flex-col items-center justify-end pb-14 h-full'>
        <Animated.Component className='text-left w-full text-white'>
          <h1 className='text-4xl font-bold  mb-1'>Welcome back!</h1>
          <p className='mb-5 text-left w-full text-neutral-500'>We`re so excited to see you again!</p>
        </Animated.Component>
        <Formik
          innerRef={formRef}
          initialValues={{
            email: '',
            password: '',
          }}
          onSubmit={() => {}}
        >
          <Form className='w-full'>
            <span className='text-xs uppercase mb-2 block text-neutral-500 '>Account information</span>
            <Field name='email' placeholder='Email' component={Input} />
            <Field name='password' placeholder='Password' component={Input} />
            <Link to={'/register'} className='text-sm text-primary mt-2 block'>
              Dont have account? Register.
            </Link>
          </Form>
        </Formik>

        <Button className='w-full mt-6' onClick={handleSubmit}>
          Login
        </Button>
      </ScrollableContainer>
    </Screen>
  );
};

export default LoginScreen;
